export class User {
  id?: string;
  company_name?:string;
  email?: string;
  password?: string;
  fullname?: string;
  roles?: Array<string>;
  token?: string;
  dateCreated?: number;
  dateLastRoleModified?: number;
  dob?: number;
  emailId?: string;
  firstName?: string;
  isstoreperson?: string;
  lastLogIn?: number;
  lastName?: string;
  lastpwchange?: number;
  salt?: string;
  timezoneId?: string;
  urlName?: string;
  uuid?: string;
  departments?:any;
  fbToken?:string;
  userAgent?:string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/user.ts